import React, { Fragment, forwardRef, useRef, useState } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import CardsSlider from "../common/CardsSlider";
// eslint-disable-next-line react/display-name
const Facilities = forwardRef(({ facilitiesData }, ref) => {
    return (
        <div ref={ref}>
            <CardsSlider
                header={facilitiesData?.Header}
                Img_Desktop={facilitiesData?.Img_Desktop}
                Img_Mobile={facilitiesData?.Img_Mobile}
                data={facilitiesData?.Our_Facilities}
            />
        </div>
    );
});

export default Facilities;
